/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import axios from 'axios'
import { jwtDecode } from 'jwt-decode'

import { apiUrl } from 'http-client'
import { AuthApiResponse } from 'utils/apiInterfaces'

interface AuthState {
  loading: boolean
  authData: AuthApiResponse
  error: string
  isAuthenticated: boolean
}

const initialState: AuthState = {
  loading: false,
  error: '',
  isAuthenticated: false,
  authData: {
    groupName: [''],
    userName: '',
    email: '',
    exp: 0,
    sub: '',
    iat: 0,
    claims: [],
  },
}

export const fetchAuthClaims = createAsyncThunk(
  'auth/fetchAuthClaims',
  async (accessToken: string) => {
    const getToken = await axios.get(`${apiUrl}/v1/authorize`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
    const {
      data: {
        data: { accessToken: jwtToken },
      },
    } = getToken
    if (jwtToken) {
      localStorage.setItem('jwtToken', jwtToken)
      // setting the jwt token
    }
    const decodedToken: AuthApiResponse = jwtDecode(jwtToken)
    return decodedToken
  }
)

export const AuthSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateAuthClaims: (state, action: PayloadAction<AuthApiResponse>) => {
      state.authData = { ...action.payload }
      state.loading = false
      state.isAuthenticated = true
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuthClaims.pending, (state) => {
        state.loading = true
      })
      .addCase(
        fetchAuthClaims.fulfilled,
        (state, action: PayloadAction<AuthApiResponse>) => {
          state.authData = { ...action.payload }
          state.loading = false
          state.isAuthenticated = true
        }
      )
      .addCase(fetchAuthClaims.rejected, (state) => {
        state.authData.claims = []
        state.loading = false
        state.error = 'Not Found'
        state.isAuthenticated = false
      })
  },
})

export default AuthSlice?.reducer

export const { updateAuthClaims, setLoading } = AuthSlice.actions
